/**
 * React Query hooks for tenant settings
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from '@intellimon/shared/components';
import { getTenantSettings, updateTenantSettings } from '../api/tenantSettings';
import type { TenantSettingsData } from '../api/tenantSettings';

export const tenantSettingsKeys = {
  all: ['tenant-settings'] as const,
  detail: () => [...tenantSettingsKeys.all, 'detail'] as const,
};

export function useTenantSettings() {
  return useQuery({
    queryKey: tenantSettingsKeys.detail(),
    queryFn: getTenantSettings,
  });
}

export function useUpdateTenantSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<TenantSettingsData>) => updateTenantSettings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tenantSettingsKeys.all });
      toast.success('Settings saved');
    },
    onError: () => {
      toast.error('Failed to save settings');
    },
  });
}
